import React from "react";
export const REACT_MAJOR_VERSION = parseInt(React.version.split('.')[0], 10);
export const isRsc = REACT_MAJOR_VERSION >= 19 && React.useState === undefined;